import { Link, useLocation } from 'react-router-dom'
import AuthButton from '../auth/AuthButton'
import NavMenu from './NavMenu'
import HeaderShell from './HeaderShell'
import { useCommonT } from '../../i18n'
import { navV2Enabled } from '../../lib/navV2'
import HeaderV2 from './HeaderV2'

// The five product surfaces stay one click away; everything secondary lives
// in NavMenu. Home left the list because the logo IS the home link.
//
// Explore joined on 2026-09-07. The Library used to be a segment of /decks,
// which is in this list; the Decks/Explore split moved it to /explore, whose
// only door was item 6 of 9 in the hamburger, below Blog and Guides. It KEEPS
// that NavMenu entry: this nav is `hidden md:flex`, and Explore is not in the
// mobile tab bar, so the menu is a phone's only way to reach it.
// `id` keys the label (common:nav.<id>).
const NAV_ITEMS = [
  { path: '/bracket', id: 'bracket' },
  { path: '/build', id: 'build' },
  { path: '/decks', id: 'my_decks' },
  { path: '/explore', id: 'explore' },
  { path: '/rules', id: 'ask_the_judge' },
] as const

// Navigation v2 (src/lib/navV2.ts) swaps in HeaderV2; flag off renders
// HeaderV1 below, unchanged.
export default function Header() {
  return navV2Enabled() ? <HeaderV2 /> : <HeaderV1 />
}

function HeaderV1() {
  const location = useLocation()
  const t = useCommonT()

  return (
    <HeaderShell>
      <Link to="/" className="text-white font-bold text-lg tracking-tight transition-opacity hover:opacity-80">
        {/* eslint-disable-next-line i18next/no-literal-string -- brand name */}
        {'CommanderBracket'}
      </Link>

      {/* ONE NavMenu and ONE AuthButton across breakpoints - only the
          primary links are breakpoint-gated. Duplicate instances would
          hold independent open state across a viewport resize. */}
      <div className="flex items-center gap-4">
        <nav aria-label={t('nav.primary_label')} className="hidden md:flex items-center gap-6">
          {NAV_ITEMS.map(({ path, id }) => (
            <Link
              key={path}
              to={path}
              className={`text-sm font-medium transition-colors ${
                location.pathname === path
                  ? 'text-white'
                  : 'text-gray-400 hover:text-gray-200'
              }`}
            >
              {t(`nav.${id}`)}
            </Link>
          ))}
        </nav>
        <NavMenu />
        <AuthButton />
      </div>
    </HeaderShell>
  )
}
